import { render } from "./CargaMes.vue?vue&type=template&id=027e39f1&scoped=true"
import script from "./CargaMes.vue?vue&type=script&lang=js"
export * from "./CargaMes.vue?vue&type=script&lang=js"

import "./CargaMes.vue?vue&type=style&index=0&id=027e39f1&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027e39f1"]])

export default __exports__